import * as Api from '@ViewModels';
import { StyleDeclarationValue } from 'aphrodite';
import { styleSheet } from './styles';

export const getCampaignStatusValues = (
	campaignVm: Api.ResourceSelectorAutomationReportViewModel | Api.AutomationReportViewModel<Api.UserSessionContext>
) => {
	let latestStep = null;
	let processStatus = null;
	const IS_RESOURCE_SELECTOR = campaignVm instanceof Api.ResourceSelectorAutomationReportViewModel;
	const IS_AUTOMATION_REPORT = campaignVm instanceof Api.AutomationReportViewModel;
	if (IS_RESOURCE_SELECTOR) {
		latestStep = campaignVm.latestCommunicationStep;
		processStatus = latestStep?.status?.status;
	}
	if (IS_AUTOMATION_REPORT) {
		processStatus = campaignVm?.status?.status;
	}
	let colorStyle: StyleDeclarationValue = null;
	let dateString = '';
	let datePrefix = 'for';
	let statusText: string = processStatus;
	switch (processStatus) {
		case Api.ProcessStatus.Completed: {
			colorStyle = styleSheet.green;
			dateString = campaignVm.status.completedDate;
			datePrefix = 'on';
			statusText = 'Sent';
			break;
		}
		case Api.ProcessStatus.Cancelled:
		case Api.ProcessStatus.Failed:
		case Api.ProcessStatus.Skipped: {
			colorStyle = styleSheet.red;
			dateString = IS_RESOURCE_SELECTOR
				? latestStep.status.cancelledDate || latestStep.status.skippedDate || latestStep.status.errorDate
				: campaignVm.status.cancelledDate || campaignVm.status.skippedDate || campaignVm.status.errorDate;
			datePrefix = 'on';
			break;
		}
		case Api.ProcessStatus.Started: {
			colorStyle = styleSheet.blue;
			dateString = IS_RESOURCE_SELECTOR ? latestStep.status.startedDate : campaignVm.status.startedDate;
			datePrefix = 'on';
			break;
		}
		case Api.ProcessStatus.Queued: {
			colorStyle = styleSheet.blue;
			dateString = IS_RESOURCE_SELECTOR ? latestStep.dueDate : campaignVm.dueDate;
			statusText = 'Scheduled';
			break;
		}
		default: {
			break;
		}
	}

	return {
		colorStyle,
		datePrefix,
		dateString,
		processStatus,
		statusText,
	};
};
